// src/pages/Skills.jsx
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
// 1. Chemin vérifié pour Skill
import Skill from "../Components/SkillsComponent";
import { useLanguageContent } from "../Components/LangueContentLoader";

export default function Skills() {
  const [activeTab, setActiveTab] = useState("marketing");
  const content = useLanguageContent();

  const tabs = [
    {
      key: "marketing",
      label:
        content?.SkillsSection?.marketingLabel ||
        "Marketing & communication & design",
      content: (
        <div style={{ minWidth: "300px" }}>
          <h1> {content.skillsSection.Skills}</h1>
          {[
            { name: content.skillsSection.Skill1, percent: 90 },
            { name: content.skillsSection.Skill2, percent: 80 },
            { name: content.skillsSection.Skill3, percent: 85 },
            { name: content.skillsSection.Skill4, percent: 75 },
            { name: content.skillsSection.Skill5, percent: 85 },
            { name: content.skillsSection.Skill6, percent: 75 },
            { name: content.skillsSection.Skill7, percent: 90 },
          ].map((s) => (
            <Skill key={s.name} name={s.name} percent={s.percent} />
          ))}
          <div>
          
            <h1 style={{ marginTop: "20px" }}> {content.skillsSection.Tools}</h1>
            {[
              { name: "Google Ads", percent: 90 },
              { name: "Google Analytics", percent: 90 },
              { name: "Photoshop", percent: 80 },
              { name: "Illustrator", percent: 75 },
              { name: "PremièrePro", percent: 30 },
              { name: "CapCut", percent: 80 },
              { name: "WORDS", percent: 80 },
              { name: "EXCEL", percent: 70 },
              { name: "Canva", percent: 90 },
            ].map((s) => (
              <Skill key={s.name} name={s.name} percent={s.percent} />
            ))}
          </div>
        </div>
      ),
    },
    {
      key: "developpement",
      label: content?.SkillsSection?.devLabel || "Développement web",
      content: (
        <div style={{ minWidth: "300px" }}>
          {[
            { name: "HTML/CSS", percent: 90 },
            { name: "JavaScript", percent: 70 },
            { name: "PHP", percent: 60 },
            { name: "MYSQL", percent: 80 },
            { name: "PYTHON", percent: 10 },
            { name: "React", percent: 70 },
            { name: "Bootstrap", percent: 90 },
            { name: "WORDPRESS", percent: 80 },
          ].map((s) => (
            <Skill key={s.name} name={s.name} percent={s.percent} />
          ))}
        </div>
      ),
    },
  ];

  // 4. fallback si jamais activeTab n'existe pas
  const active = tabs.find((t) => t.key === activeTab) || tabs[0];

  const fadeVariants = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -10 },
  };

  return (
    <motion.main
      className="skills-container"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={fadeVariants}
      transition={{ duration: 0.5 }}
      style={{ padding: "2rem" }}
    >
      <nav
        role="tablist"
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "2rem",
        }}
      >
        {tabs.map((tab) => (
          <button
            key={tab.key}
            role="tab"
            aria-selected={activeTab === tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              background: "none",
              border: "none",
              fontSize: "clamp(20px, 3vw, 38px)",
              fontWeight: "bold",
              cursor: "pointer",
              borderBottom:
                activeTab === tab.key
                  ? "2px solid #eb5939"
                  : "2px solid transparent",
              color: activeTab === tab.key ? "#b7ab98" : "#777",
            }}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      <AnimatePresence mode="wait">
        <motion.div
          key={active.key}
          variants={fadeVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.3 }}
          style={{ marginTop: "2rem" }}
        >
          {active.content}
        </motion.div>
      </AnimatePresence>
    </motion.main>
  );
}
